import React, { useState } from 'react'
import { withTranslation, Trans } from 'react-i18next'
import VisibilitySensor from 'react-visibility-sensor'

import Toggle from '../components/Toggle'

import RegistrationBlock from '../components/Registration'
import SEO from '../components/SEO'

import Img1 from '../images/png/howItWorks/image1.png'
import Img2 from '../images/png/howItWorks/image2.png'
import Img3 from '../images/png/howItWorks/image3.png'
import Img4 from '../images/png/howItWorks/image4.png'
import Art1 from '../images/png/howItWorks/art1.png'
import Art2 from '../images/png/howItWorks/art2.png'
import Art3 from '../images/png/howItWorks/art3.png'
import ImgLike from '../images/png/howItWorks/like.png'
import BoyAndGirl from '../images/png/howItWorks/boyAndGirl.png'

import { Helmet } from 'react-helmet'

let initCards = [false, false, false, false]
const HowItWorks = ({ t }) => {
    const [isOpened, setIsOpened] = useState(initCards)

    const toggleCard = index => {
        const newArr = [...initCards]
        newArr[index] = !isOpened[index]
        setIsOpened(newArr)
    }

    const classNameCard1 = `card${isOpened[0] ? ' is-active' : ''}`
    const classNameCard2 = `card${isOpened[1] ? ' is-active' : ''}`
    const classNameCard3 = `card${isOpened[2] ? ' is-active' : ''}`
    const classNameCard4 = `card${isOpened[3] ? ' is-active' : ''}`

    // const [checkList, setCheckList] = useState([false, false, false])
    function handleTogglesChange(index, value) {
        // const newArr = [...checkList]
        // newArr[index] = value
        // setCheckList(newArr)
        // if (index === 0) { // do stuff }
    }

    const [check1, setCheck1] = useState(false)
    const [check2, setCheck2] = useState(false)
    const [check3, setCheck3] = useState(false)
    function onChangeToggle1(isVisible) {
        if (isVisible && !check1) {
            setCheck1(true)
        }
    }
    function onChangeToggle2(isVisible) {
        if (isVisible && !check2) {
            setCheck2(true)
        }
    }
    function onChangeToggle3(isVisible) {
        if (isVisible && !check3) {
            setCheck3(true)
        }
    }

    return (
        <div className="container-static-pages how-it-works">
            <SEO title={t('_pages._how_it_works._SEO.title')} />

            <h1>{t('_pages._how_it_works.h1')}</h1>

            <article className="article article--1">
                <Trans i18nKey="_pages._how_it_works._articles.1" />
            </article>

            <div className="toggle-box">
                <VisibilitySensor onChange={onChangeToggle1}>
                    <Toggle
                        id={0}
                        isChecked={check1}
                        // isChecked={checkList[0]}
                        isDisabled={true}
                        onChange={handleTogglesChange}
                    />
                </VisibilitySensor>
            </div>

            <h2 className="h2 h2--1">
                <Trans i18nKey="_pages._how_it_works._h2.1" />
            </h2>

            <div className="cards-list">
                <div className={classNameCard1} onClick={() => toggleCard(0)}>
                    <div className="flipper">
                        <div className="front">
                            <div className="title">{t('_pages._how_it_works._cards._1.title')}</div>
                            <div className="img">
                                <img src={Img1} alt="img" />
                            </div>
                        </div>
                        <div className="back">
                            <div className="profit profit--1">x4</div>
                            <article>{t('_pages._how_it_works._cards._1.article')}</article>
                        </div>
                    </div>
                </div>
                <div className={classNameCard2} onClick={() => toggleCard(1)}>
                    <div className="flipper">
                        <div className="front">
                            <div className="title">{t('_pages._how_it_works._cards._2.title')}</div>
                            <div className="img">
                                <img src={Img2} alt="img" />
                            </div>
                        </div>
                        <div className="back">
                            <div className="profit profit--2">x2</div>
                            <article>{t('_pages._how_it_works._cards._2.article')}</article>
                        </div>
                    </div>
                </div>
                <div className={classNameCard3} onClick={() => toggleCard(2)}>
                    <div className="flipper">
                        <div className="front">
                            <div className="title">{t('_pages._how_it_works._cards._3.title')}</div>
                            <div className="img">
                                <img src={Img3} alt="img" />
                            </div>
                        </div>
                        <div className="back">
                            <div className="profit profit--3">
                                <img src={ImgLike} alt="like" />
                            </div>
                            <article>{t('_pages._how_it_works._cards._3.article')}</article>
                        </div>
                    </div>
                </div>
                <div className={classNameCard4} onClick={() => toggleCard(3)}>
                    <div className="flipper">
                        <div className="front">
                            <div className="title">{t('_pages._how_it_works._cards._4.title')}</div>
                            <div className="img">
                                <img src={Img4} alt="img" />
                            </div>
                        </div>
                        <div className="back">
                            <div className="profit profit--4">63%</div>
                            <article>{t('_pages._how_it_works._cards._4.article')}</article>
                        </div>
                    </div>
                </div>
            </div>

            <div className="toggle-box">
                <VisibilitySensor onChange={onChangeToggle2}>
                    <Toggle
                        id={1}
                        isChecked={check2}
                        // isChecked={checkList[1]}
                        isDisabled={true}
                        mainColor={'#34C86D'}
                        onChange={handleTogglesChange}
                    />
                </VisibilitySensor>
            </div>

            <h2 className="h2 h2--2">
                <Trans i18nKey="_pages._how_it_works._h2.2" />
            </h2>
            <article className="article article--2">{t('_pages._how_it_works._articles.2')}</article>

            <h2 className="h2 h2--3">
                <Trans i18nKey="_pages._how_it_works._h2.3" />
            </h2>

            <ul className="situation">
                <li className="item">
                    <div className="img">
                        <img src={Art1} alt="" />
                    </div>
                    <p>{t('_pages._how_it_works._situation.1')}</p>
                </li>
                <li className="item">
                    <div className="img">
                        <img src={Art2} alt="" />
                    </div>
                    <p>{t('_pages._how_it_works._situation.2')}</p>
                </li>
                <li className="item">
                    <div className="img">
                        <img src={Art3} alt="" />
                    </div>
                    <p>{t('_pages._how_it_works._situation.3')}</p>
                </li>
            </ul>

            <article className="article article--3">{t('_pages._how_it_works._articles.3')}</article>

            <div className="boy-girl">
                <img src={BoyAndGirl} alt="boy & girl" />
            </div>
            <article className="article article--4">{t('_pages._how_it_works._articles.4')}</article>

            <div className="toggle-box">
                <VisibilitySensor onChange={onChangeToggle3}>
                    <Toggle
                        id={2}
                        isChecked={check3}
                        // isChecked={checkList[2]}
                        isDisabled={true}
                        mainColor={'#24BFD8'}
                        onChange={handleTogglesChange}
                    />
                </VisibilitySensor>
            </div>
            <h2 className="h2 h2--4">
                <Trans i18nKey="_pages._how_it_works._h2.4" />
            </h2>
            <article className="article article--5">{t('_pages._how_it_works._articles.5')}</article>

            <div className="link">
                <a
                    href="mailto:info@interacty.me"
                    className="button-style"
                    data-size="lg"
                    data-variant="black-white--2"
                >
                    {t(`_pages._how_it_works.contact_us`)}
                </a>
            </div>

            <RegistrationBlock bgColor="#F3F7FA" />
        </div>
    )
}

export default withTranslation('translations')(HowItWorks)
